import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import "../../../styles/components/insights/insights/MostUsedEV.scss";
import favourite_car from "../../../styles/images/favourite_car.svg";
import car from "../../../styles/images/car_lightgrey.svg";
import "../../../styles/utils/_loadingScreen.scss";

class MostUsedEV extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="mostUsedEV" className="highlight-container">
        {!this.props.loading ? (
          <>
            <div className="highlight-container-header">
              <img src={favourite_car} alt="" />
              <Translate value="insights_mostUsedEV" />
            </div>
            <div className="highlight-container-body">
              <div className="ev-container">
                {this.props.ev &&
                this.props.ev !== "-1" &&
                Object.keys(this.props.ev).length > 0 ? (
                  <>
                    <div className="ev-header">
                      <div className="ev-info">
                        <p>
                          {this.props.ev?.brand ?? ""} {this.props.ev?.model ?? ""}
                        </p>
                        <p>{this.props.ev && this.props.ev.licensePlate}</p>
                      </div>
                      {this.props.ev && this.props.ev.primaryEV && <p><Translate value="evs_primary" /></p>}
                    </div>
                    <div className="ev-image">
                      <img
                        src={
                          this.props.ev && this.props.ev.imageContent
                            ? this.props.ev.imageContent
                            : car
                        }
                        alt=""
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="ev-image">
                      <img src={car} alt="" style={{maxWidth: '100px'}} />
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="loading-container">
            <div className="loading-spinner">
              <div className="generic-loading">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MostUsedEV;
